import React, {useEffect, useState} from 'react';
import {makeStyles, withStyles} from '@material-ui/core/styles';
import {Card, Typography, Button, TextField, Grid, CircularProgress} from '@material-ui/core/';
import axios from 'axios';
import {useTranslation} from "react-i18next";
import * as constants from "../../common/Constants";
import Loader from "../../../common/Loader";

const SourceButton = withStyles({
    root: {
        width: '100%',
        borderRadius: 10,
        border: '1px solid #e0dfe0',
        height: 40,
        marginBottom: 10,
        textTransform: 'none',
        '&.active': {
            backgroundColor: '#39bb0f',
            color: 'white',
            borderColor: '#39bb0f',
        },
    },
})(Button);

const useStyles = makeStyles({
    root: {
        width: '100%',
        boxShadow: "none",
        padding: '00px'
    },
    title: {
        fontSize: 14,
        fontWeight: 'bold',
        marginBottom: 10
    },
    input: {
        marginBottom: 10
    }
});

export default function LiveSourceSwitcher() {
    const {t} = useTranslation();
    const classes = useStyles();
    const [loading, setLoading] = useState(false);
    const [activeSource, setActiveSource] = useState(null);
    const [sources, setSources] = useState([]);

    const loadSources = async () => {
        setLoading(true);
        try {
            const response = await axios.post(constants.LocalUrl + "/data/get_stage_sources");
            setSources(response.data.sources || []);
            // Use loose inequality if data types might differ, or better, cast to Number
            const active = response.data.active_source !== null && response.data.active_source !== undefined
                ? Number(response.data.active_source)
                : 0;
            setActiveSource(active);
        } catch (error) {
            console.error("Error loading sources", error);
        }
        setLoading(false);
    };

    useEffect(() => {
        loadSources();
    }, []);

    const handleSourceChange = (index) => {
        const indexToSet = Number(index);
        setActiveSource(indexToSet);
        axios.post(constants.LocalUrl + "/data/set_stage_source", {index: indexToSet})
            .then(response => {
                // Handle success
            })
            .catch(error => {
                console.error("Error setting source", error);
            });
    };

    if (loading) return <Loader />;

    return (
        <Card className={classes.root}>
            {/*<Typography className={classes.title} color="textSecondary">*/}
            {/*    {t('LIVE SOURCE SWITCHER')}*/}
            {/*</Typography>*/}
            <Typography variant="body2" gutterBottom>
                {t('Select which of the configured Stage Streams should be active.')}
            </Typography>

            <div style={{marginTop: '20px'}}>
                {sources.map((source, index) => (
                    <div key={index} style={{marginBottom: '10px'}}>
                        <SourceButton
                            className={Number(activeSource) === index ? 'active' : ''}
                            onClick={() => handleSourceChange(index)}
                        >
                            {Number(activeSource) === index ? `${t('ACTIVE')}: ${source.name || t('Stream') + ' ' + (index + 1)}` : `${t('SWITCH TO')}: ${source.name || t('Stream') + ' ' + (index + 1)}`}
                        </SourceButton>
                    </div>
                ))}
            </div>
        </Card>
    );
}
